<button type="button" class="btn"
  [ngClass]="classList"
  [disabled]="isLoading()"
  [class.is-loading]="isLoading()"
  (click)="redirectToAuth()"
>
  <i class="icon" [ngClass]="icon"></i>

  @if (text) {
    <span class="btn__text">
      {{ text }}
    </span>
  }
</button>
